<p-toast/>

@if (loading()) {
  <p-skeleton height="300px" borderRadius="12px"></p-skeleton>
} @else if (comparativa()) {

  <div class="flex justify-between items-center mb-6">
    <div>
      <div class="flex items-center gap-3">
        <h1 class="text-2xl font-bold">Comparativa Oferta #{{ comparativa()!.oferta.id }}</h1>
        <p-tag
          severity="danger"
          pTooltip="El RGPD no está aceptado por el usuario"
          tooltipPosition="top"
          class="cursor-pointer flex items-center gap-2"
        >
          <p-checkbox [binary]="true" [disabled]="true" [ngModel]="false"></p-checkbox>
          <span>RGPD</span>
        </p-tag>
      </div>
      <h2 class="text-xl text-slate-600 mt-3">
        Cliente: {{ comparativa()!.oferta.nombreCliente }} |
        CUPS: {{ comparativa()!.oferta.cups }} |
        Compañía: {{ comparativa()!.oferta.companiaActual }} |
        Tarifa: {{ comparativa()!.oferta.tipoTarifa }}
      </h2>
    </div>
    <div class="flex gap-2">
      <p-button label="Volver" icon="pi pi-arrow-left" (onClick)="volver()" styleClass="p-button-text"/>
      <p-button label="Imprimir tabla" icon="pi pi-print" (onClick)="imprimir()"/>
    </div>
  </div>

  <div>
    <div class="bg-white rounded-xl shadow mt-4">
      <p-table
        class="comparativa-tabla"
        [value]="comparativa()!.comparativa"
        [paginator]="true"
        [rows]="20"
        styleClass="shadow-sm rounded-xl overflow-hidden"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords}"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="proveedor">
              Proveedor
              <p-sortIcon field="proveedor"></p-sortIcon>
            </th>
            <th pSortableColumn="ahorroEstimadoMensual">
              Ahorro mensual
              <p-sortIcon field="ahorroEstimadoMensual"></p-sortIcon>
            </th>
            <th pSortableColumn="ahorroEstimadoAnual">
              Ahorro anual
              <p-sortIcon field="ahorroEstimadoAnual"></p-sortIcon>
            </th>
            <th pSortableColumn="porcentajeAhorro">
              % Ahorro
              <p-sortIcon field="porcentajeAhorro"></p-sortIcon>
            </th>
            <th pSortableColumn="comision">
              Comisión
              <p-sortIcon field="porcentajeAhorro"></p-sortIcon>
            </th>
            <th>Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td class="font-medium">{{ row.proveedor }}</td>
            <td>{{ row.ahorroEstimadoMensual | number:'1.2-2':'es-ES' }} €</td>
            <td>{{ row.ahorroEstimadoAnual | number:'1.2-2':'es-ES' }} €</td>
            <td>
              <p-tag
                [value]="row.porcentajeAhorro + '%'"
                [severity]="row.porcentajeAhorro > 0 ? 'success' : row.porcentajeAhorro < 0 ? 'danger' : 'info'"/>
            </td>
            <td class="font-semibold">50 €</td>
            <td>
              <p-button
                icon="pi pi-file-pdf"
                label="Oferta"
                styleClass="p-button-text p-button-danger"
                (onClick)="descargarPdf(row)"/>
              <p-button
                icon="pi pi-envelope"
                label="Enviar"
                styleClass="p-button-text p-button-info"
                (onClick)="enviarOferta(row)"/>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <p-dialog
    header="Confirmación"
    [(visible)]="mostrarModal"
    [modal]="true"
    [closable]="false"
    [style]="{ width: '400px' }">
    <p>Oferta enviada correctamente ✅</p>
    <ng-template pTemplate="footer">
      <p-button label="Cerrar" icon="pi pi-check" (onClick)="mostrarModal=false"/>
    </ng-template>
  </p-dialog>
}
